module.exports = __webpack_public_path__ + "assets/img/d8b5-ec.svg";